module.exports = __webpack_public_path__ + "fonts/BarlowCondensed-Regular.1e9d32a.woff2";